export function StateAccessControlService($state, Settings, ACCESS_LEVEL) {
    const service = {};

    function isPendingPromise(promise) {
        return promise.$$state && promise.$$state.status === 0;
    }

    service.redirectIfUnauthorized = function redirectIfUnauthorized(event, toState, toParams) {
        const getSettings = Settings.get();

        if (isPendingPromise(getSettings)) {
            event.preventDefault();
            getSettings.then(() => {
                $state.go(toState, toParams);
            }).catch(() => {
                $state.go('noaccess');
            });
        } else {
            const aclRequired = toState.data && toState.data.acl,
                accessLevel = toState.data && toState.data.accessLevel,
                isAccessBlocked = accessLevel
                    ? aclRequired && Settings.getRoleACLForFunction(aclRequired) < accessLevel
                    : aclRequired && Settings.getRoleACLForFunction(aclRequired) === ACCESS_LEVEL.None;

            if (isAccessBlocked) {
                event.preventDefault();
                $state.go('noaccess');
            }
        }
    };

    return service;
}
StateAccessControlService.$inject = ['$state', 'Settings', 'ACCESS_LEVEL'];
